import type { PatchRelease } from "../types";

export const release: PatchRelease = {
  id: "2026-06-22_01",
  version: "2026.06.22",
  date: "22 Jun 2026",
  sinceCommit: "abb7bde",
  gameplay: [
    {
      text: "Everyone now starts with **Teleport** on **Spacebar** (in addition to **Fireball** and **Scourge**) in every mode — Classic, Skill Draft, PvE, and All Random. Space still does not count toward the **8**-spell cap; shop and draft fill **1 → R** only.",
    },
    {
      text: "**All Random** reworked: each round reveals **1** skill (while bar space remains), **2** stat passives, and **1** synergy when eligible — no gold, items, or spell level upgrades; power comes from passives and synergies.",
    },
    {
      text: "Skill Draft / Classic: every spell unlock and upgrade costs **1 SP** (was tiered **1-3 SP** by catalog price).",
    },
    {
      text: "Signed-in players can **reconnect** to an in-progress match from the main menu. **Email sign-in** (register / sign in with password) is available when accounts are enabled.",
    },
    {
      text: "Void locomotion while over the rim: move accel **55% → 75%**, facing turn rate **50% → 70%** of normal.",
    },
    {
      text: "Knockback: repeated hits within **0.6s** now use diminishing impulse",
    },
    {
      text: "Creating or joining a custom lobby after matchmaking no longer loses lobby updates — Classic shop picks apply correctly again.",
    },
    {
      text: "**Aurelion** joins the gauntlet as the third boss — a void-lantern sentinel pinned to the arena's heart, its light sweeping the disc without rest. An open floor; no stone to hide behind.",
    },
    {
      text: "**PvE dungeon expanded to eight bosses.** The gauntlet runs **Inferna → Titan → Aurelion → Grosh'kar → Vorathal → Ix'tholoth → Kael → The Twin Sisters**. Before each fight, your party gets a briefing on who you're facing — hit **Ready** when you're set to drop in.",
    },
    {
      text: "**Grosh'kar, the Bloodgorged** — a bloated plague-brute crawled up from the rot under the slab. The fight is a slow, sickening war of attrition; the longer it drags, the hungrier he gets. Don't huddle for safety.",
    },
    {
      text: "**Vorathal, the Drowned Tempest** — a frost-wreathed leviathan frozen into the platform. Less about raw burn than about where you stand: the ice, the wind, and the rim are the real threat. The floor is the boss.",
    },
    {
      text: "**Ix'tholoth, the Hollow Eye** — something old and half-born stares up through a rift at the arena's centre. It turns your instincts against you; only the four stone pillars break its line of sight to the disc.",
    },
    {
      text: "**Kael the Unbound** — a robed duelist who is never quite where you aim. Misdirection and stolen ground, not brute force — read the fight before you commit your burst.",
    },
    {
      text: "**The Twin Sisters** — Morwenna's gold and Lys's void, bound to one life across two bodies. The finale is a coordination test: light against dark on an open stage, with nowhere to hide from either sister's gaze.",
    },
    {
      text: "**PvE** now uses the **Classic shop** between encounters (was Skill Draft).",
    },
    {
      text: "**PvE fixes:** poison pools, ice patches, and wind fields render correctly again; **Contagion** clears between rounds; **Dominate Mind** no longer lets you aim or cast while controlled; **Plague Burst** shows the same top-of-screen telegraph as Inferno Nova (stand in poison, not behind stone).",
    },
  ],
  skills: [
    {
      spellId: "voidbeam",
      changes: [
        {
          text: "Firing no longer kicks you backward; instead you are slowed to **72%** move speed for **2s** and exhaust your cooldowns (**+2s** per spell for **4s**).",
        },
        {
          passiveId: "voidbeam_damage",
          text: "Passive renamed **Heavier Recoil** → **Overcharge** (still **+20%** damage).",
        },
        {
          passiveId: "frozenorb_void_maelstrom",
          text: "**Void Maelstrom** synergy beams no longer knock back.",
        },
      ],
    },
    {
      spellId: "bonespear",
      changes: [
        {
          text: "Channel windup **1.0s → 0.8s**",
        },
      ],
    },
    {
      spellId: "windwalk",
      changes: [
        {
          text: "Invis sprint contact now checks your movement path each tick — fast dashes no longer slip through enemies without triggering the slam.",
        },
      ],
    },
  ],
};
